import { toast } from '@metadevprofile/ui/web';

const DEDUPE_WINDOW_MS = 2_000;

const lastShownAt = new Map<string, number>();

const shouldShow = (kind: string, message: string): boolean => {
  const key = `${kind}:${message}`;
  const now = Date.now();
  const previous = lastShownAt.get(key);
  if (previous !== undefined && now - previous < DEDUPE_WINDOW_MS) {
    return false;
  }
  lastShownAt.set(key, now);
  return true;
};

interface NotificationOptions {
  type: 'success' | 'error' | 'warning' | 'info';
  message: string;
  description?: string;
  duration?: number;
}

class NotificationService {
  notify({ type, message, description, duration = 4000 }: NotificationOptions): void {
    if (!shouldShow(type, message)) return;

    const options = {
      description,
      timeout: duration,
    };

    switch (type) {
      case 'success':
        toast.success(message, options);
        break;
      case 'error':
        toast.danger(message, options);
        break;
      case 'warning':
        toast.warning(message, options);
        break;
      case 'info':
        toast.info(message, options);
        break;
      default:
        toast(message, options);
    }
  }

  success(message: string, description?: string): void {
    this.notify({ type: 'success', message, description });
  }

  error(message: string, description?: string): void {
    this.notify({ type: 'error', message, description });
  }

  warning(message: string, description?: string): void {
    this.notify({ type: 'warning', message, description });
  }

  info(message: string, description?: string): void {
    this.notify({ type: 'info', message, description });
  }
}

export const notificationService = new NotificationService();
